import type { AxiosResponse } from 'axios';
import type { TranscriptComment } from '@trinity/chat/types/transcribe.rich-text';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { type UseQueryOptions, useQueryWrapper } from '@trinity/chat-components/hooks/useQueryWrapper';
import { queryKeys } from '@trinity/chat-components/query-keys/index.js';

type Props = {
  transcriptId: number;
};

export const useTranscriptionComments = (props: Props, options: Omit<Options, 'queryKey' | 'queryFn'> = {}) => {

  const apiClient = useChatApiClient();

  return useQueryWrapper({
    queryKey: queryKeys.transcripts.comments(props),
    queryFn: ({ queryKey }) => {
      const params = queryKey[1];

      return apiClient.transcripts.getTranscriptComments(params)
        .then(res => res.comments);
    },
    ...options,
  });
};

type Data = TranscriptComment[];
type QK = ReturnType<typeof queryKeys.transcripts.comments>;

type Options = UseQueryOptions<Data, AxiosResponse, Data, QK>;
